import type { ReactNode } from 'react';
import type { PublicMenuNavbarStyle } from '../../shared/public-menu-theme';

interface PublicMenuNavbarProps {
  name: string; // non-empty; callers coalesce ('Mi restaurante' fallback is caller-side)
  subtitle?: string;
  logoUrl?: string;
  navbarStyle: PublicMenuNavbarStyle;
  trailing?: ReactNode; // opaque; caller-owned behavior
}

export function PublicMenuNavbar({ name, subtitle, logoUrl, navbarStyle, trailing }: PublicMenuNavbarProps) {
  return (
    <header
      className="public-menu-navbar sticky top-0 z-30 border-b border-border backdrop-blur-xl"
      data-navbar-style={navbarStyle}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <div className="flex min-w-0 items-center gap-3">
          {logoUrl ? (
            <img alt={`Logo de ${name}`} className="size-11 rounded-[var(--menu-radius)] object-cover" src={logoUrl} />
          ) : (
            <div className="grid size-11 place-items-center rounded-[var(--menu-radius)] bg-[var(--menu-accent)] font-black text-[var(--menu-accent-foreground)]">{name.slice(0, 1).toUpperCase()}</div>
          )}
          <div className="min-w-0">
            <h1 className="truncate font-black tracking-tight text-current">{name}</h1>
            {subtitle != null && <p className="truncate text-xs text-current opacity-75">{subtitle}</p>}
          </div>
        </div>
        {trailing}
      </div>
    </header>
  );
}